import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Modal, Icon, Select, Button, Input, Radio } from "semantic-ui-react";
import { toast } from "../..";
import { IClientContract } from "../../models/clientContract";
import { editClientContract } from "../../api/clientContract";
import { CalendarInput } from "../../components/CalendarInput/CalendarInput";
import { getISODateFormat } from "../../components/CalendarSelector/getAllDatesHelper";
import { contractOptions } from "../../models/clientContract";

interface IProps {
    clientContract: IClientContract;
    setClientContract: Dispatch<SetStateAction<IClientContract>>;
    open: boolean;
    closeModal: () => void;
    handleEditClientContract: () => void;
}

export const EditClientContractForm = ({
    clientContract,
    setClientContract,
    open,
    closeModal,
    handleEditClientContract,
}: IProps) => {
    const [loading, setLoading] = useState(false);

    const updateClientContract = async () => {
        setLoading(true);
        try {
            await editClientContract(clientContract);
            handleEditClientContract();
            toast("Client contract successfully added", true, 1500);
        } catch {
            toast("Error creating client contract", false, 1500);
        } finally {
            setLoading(false);
            closeModal();
        }
    };

    return (
        <Modal open={open} onClose={closeModal} dimmer="blurring" centered={false} size="tiny">
            <Modal.Header>
                <h2>Edit client contract</h2>
                <Icon name="close" onClick={closeModal} />
            </Modal.Header>
            <Modal.Content>
                <form className="add-client-contract-form">
                    <div className="client-contract-container">
                        <div className="input-container">
                            <label>Start date</label>
                            <CalendarInput
                                date={clientContract.startDate}
                                placeholder="Select date..."
                                handleDateChange={e =>
                                    setClientContract({
                                        ...clientContract,
                                        startDate: getISODateFormat(e),
                                    })
                                }
                            />
                        </div>
                        <div className="input-container">
                            <label>End date</label>
                            <CalendarInput
                                date={clientContract.endDate}
                                placeholder="Select date..."
                                handleDateChange={e =>
                                    setClientContract({
                                        ...clientContract,
                                        endDate: getISODateFormat(e),
                                    })
                                }
                            />
                        </div>
                        <div className="input-container">
                            <label>Value (HRK)</label>
                            <Input
                                value={clientContract.value}
                                onChange={(e: any) =>
                                    setClientContract({
                                        ...clientContract,
                                        value: e.target.value,
                                    })
                                }
                            />
                        </div>
                        <div className="input-container">
                            <label>Responsible person</label>
                            <Input
                                value={clientContract.responsiblePerson}
                                onChange={(e: any) =>
                                    setClientContract({
                                        ...clientContract,
                                        responsiblePerson: e.target.value,
                                    })
                                }
                            />
                        </div>
                        <div className="input-container">
                            <label>Type</label>
                            <Select
                                fluid
                                placeholder="Select contract type..."
                                selectOnBlur={false}
                                options={contractOptions}
                                value={clientContract.contractType}
                                onChange={(e, data: any) =>
                                    setClientContract({
                                        ...clientContract,
                                        contractType: data.value,
                                    })
                                }
                            />
                        </div>
                        <div className="input-container" id="isSigned-radio">
                            <label>Signed</label>
                            <Radio
                                toggle
                                label={clientContract.isSigned ? "Yes" : "No"}
                                checked={clientContract.isSigned}
                                onChange={e =>
                                    setClientContract({
                                        ...clientContract,
                                        isSigned: !clientContract.isSigned,
                                    })
                                }
                            />
                        </div>
                    </div>
                </form>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    content="Edit client contract"
                    secondary
                    fluid
                    onClick={updateClientContract}
                    disabled={loading}
                />
            </Modal.Actions>
        </Modal>
    );
};
